import axios from "axios";
import _ from 'lodash';
import { mobilizeiUsersService } from "../mobilizei/users.service";
import config from "../../utils/config";
import { apiFetcher as mobilizeiApiFetcher } from "../mobilizei/apiFetcher";

export const authIrrobaService = {
    authenticate,
    refreshAccessToken
};

function authenticate(username, password, storeId, storeName, storeUrl){
    const url = `platforms/irroba/auth`;

    const body = {
      username: username,
      password: password,
      storeId: storeId,
      storeName: storeName,
      storeUrl: storeUrl
    }

    return mobilizeiApiFetcher(url, { method: "POST", body: JSON.stringify(body) });
}

function refreshAccessToken(storeId) {
    return axios
        .post(
            `${config.MOBILIZEI_API_BASE_URL}/platforms/irroba/auth/refresh`,
            { storeId }
        )
        .then(() => {
            return mobilizeiUsersService.getSelf().then(userData => {
                return _.get(userData, 'store.accessToken', '');
            })
        })
}